import { MARK_ID_PREFIX, MARK_ID_NUMBER_LEN } from './constants';

// Get the mark identifier from an element's class name
export default function parseMarkId(className: string) {
    const indexOfMarkId = className.indexOf(MARK_ID_PREFIX);
    const lenOfMarkId = MARK_ID_PREFIX.length + MARK_ID_NUMBER_LEN;
    return className.substring(indexOfMarkId, indexOfMarkId + lenOfMarkId);
}
